import { Footer } from 'antd/lib/layout/layout';

const AppFooter = () => {
  return (
    <Footer style={{ textAlign: 'center', background: 'colorBgContainer' }}>
      LHDN E-Invoice System for Car Insurance ©{new Date().getFullYear()}
    </Footer>
  );
};

export default AppFooter;